import { login, logout, fetchUserInfo } from "@/api/user";

import { setToken, getToken, clearToken, cacheUser, encryptPasswrod } from "@/libs/util";
import Vue from "vue";

import * as types from '../types';

Vue.mixin({
  data:function(role){
    return {
      nombreMio:role
    }
  }
});

export default {
  state: {
    userName: "",
    userId: "",
    access: "",
    token: getToken(),
    hasGetInfo: false,
    //currentViewBy
    currentViewBy:'',
    currentViewByDetail: {},
    role:"",
    fullName: "",
    parenRoleOrig:"",
    parenNameOrig:"",
    parenUserIdOrig:"",
  },
  mutations: {
    [types.LOGIN]: (state, token) => {
      state.token = token;
      setToken(token);
    },
    [types.GET_USER_DATA]: (state, user) => {
      state.userName = user.firstName + ' ' + user.lastName;
      state.access = user.roles;
      state.userId = user.userId;
      state.hasGetInfo = true;
    },
    [types.LOGOUT]: (state) => {
      //clear data
      state.token = '';
      clearToken();
      state.userId = '';
      state.access = '';
      state.hasGetInfo = false;
    }
  },
  actions: {
    // 登录
    handleLogin({ commit }, { userId, password, rememberMe, encrypted }) {
      return new Promise((resolve, reject) => {
        // encrypt the password if the password hasnot encrypted
        let encryptedPw = encrypted ? password : encryptPasswrod(userId, password);

        login({ userId: userId, password: encryptedPw })
          .then(res => {
            if (res && res.success) {
              const data = res.data;
              // cache user
              if (rememberMe) cacheUser(userId, encryptedPw);
              commit(types.LOGIN, data.token);
              resolve(data);
            }
            else {
              reject(res);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 退出登录
    handleLogOut({ state, commit }) {
      return new Promise((resolve, reject) => {
        logout(state.token)
          .then(res => {
            if (res && res.success) {
              commit(types.LOGOUT);
              resolve(res.data);
            }
            else {
              reject(res);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 获取用户相关信息
    getUserInfo({ state, commit }) {
      return new Promise((resolve, reject) => {
        try {
          fetchUserInfo(state.token)
            .then(res => {
              if (res && res.success) {
                //ROLE_PRESIDENT is not used. changes to OWNER
                if(res.data.roles[0] == "ROLE_PRESIDENT") {
                  res.data.roles[0] = "ROLE_OWNER";
                }
                else if(res.data.roles[0] == "ROLE_FZD") {
                  res.data.roles[0] = "ROLE_ML";
                }
                // else if(res.data.userId == "jguith" && res.data.roles[0] == "ROLE_CSR") {
                //   res.data.roles[0] = "ROLE_ADMIN";
                // }
                // console.log("::SHOW ROLE",res.data);

                state.leaderId = res.data.userId;
                state.leaderRole = res.data.roles[0];
                state.parentName = res.data.lastName+', '+ res.data.firstName;
                state.parenNameOrig = res.data.lastName+', '+ res.data.firstName;
                state.userName = state.parenNameOrig;
                var roleArr = res.data.roles[0].split('_');
                this.leaderId = res.data.userId;
                this.leaderRole = res.data.roles[0];
                this.role = res.data.roles[0];
                state.parentRole = roleArr[1];
                console.log(state.parentRole);

                console.log(state.parentRole);
                state.parenRoleOrig = roleArr[1];
                if(res.data.userId == "jguith") {
                  state.parenRoleOrig = "ADMIN";
                  state.parentRole = "ADMIN";
                }
                state.role = res.data.roles[0];

                const user = res.data;
                console.log(user);
                commit(types.GET_USER_DATA, user);
                resolve(user);
              }
              else {
                reject(res);
              }
            })
            .catch(err => {
              reject(err);
            });
        } catch (error) {
          reject(error);
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/module/user.js